import { render } from "./StatItem.vue?vue&type=template&id=c3495532&scoped=true&ts=true"
import script from "./StatItem.vue?vue&type=script&lang=ts"
export * from "./StatItem.vue?vue&type=script&lang=ts"

import "./StatItem.vue?vue&type=style&index=0&id=c3495532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3495532"]])

export default __exports__